import info_ico from "./Fill@3x.png";
import anytimeCollect from "./Logos/AnytimeCollectAppLogo.png";
import underMaintenance from "./under_maintenance.png";
import loginBackground from "./Login/login-nofish.jpg";
import newLoginBackground from "./Login/new-login-containers.jpg";
import welcome from "./Login/welcome.png";
import loginLogo from "./Login/logo-white.png";
import loginHeaderBk from "./Login/slate.png";
import showPassword from "./Login/Eye@3x.png";
import hidePassword from "./Login/Eye With Line@3x.png";
import header from "./Nav/header.png";
import logo from "./logo.png";
import logoHorizontal from "./logo_horizontal.png";
import calendar from "./calendar.png";
import logo_white from "./Nav/tosca_logo_white.png";
import logo_white_bg_black_text from "./Nav/logo_white_bg_black_text.png";
import carrots from "./mantle_bg345.jpg";
import cheese from "./cheesemantle.jpg";
import beef from "./mantle_bg154.jpg";
import eggs from "./mantle_bg275.jpg";
import chicken from "./mantlechicken.jpg";
import default_user from "./user-default.png";
import beef_ico from "./Beef@3x.png";
import container_ico from "./Container@3x.png";
import eggs_ico from "./Eggs@3x.png";
import invoices_ico from "./Invoices@3x.png";
import poultry_ico from "./Poultry@3x.png";
import produce_ico from "./Produce@3x.png";
import return_ico from "./Return@3x.png";
import van_ico from "./Van@3x.png";
import forward from "./Forward@3x.png";
import tosca_ltd from "./tosca_ltd.png";
import tosca_new from "./tosca_new.png";
import gp from "./gp.png";
import hays from "./hays.png";
import orbis from "./orbis.png";
import polymerLogistics_6317 from "./Polymer_Logistics_6317.jpg";
import polymerLogistics_6332 from "./Polymer_Logistics_6332.jpg";
import polymerLogistics_6408 from "./Polymer_Logistics_6408.png";
import polymerLogistics_6411 from "./Polymer_Logistics_6411.png";
import polymerLogistics_6425 from "./Polymer_Logistics_6425.jpg";
import remove from "./remove.png";
import edit from "./edit.png";

/* Status Icons */
import Canceled from "./Status/Canceled.png";
import InReview from "./Status/In Review.png";
import Processing from "./Status/Processing.png";
import Received from "./Status/Received.png";
import Shipped from "./Status/Shipped.png";
import InTransit from "./Status/InTransit.png";
import TenderAccept from "./Status/TenderAccept.png";

/* Pagination Icons */
import LeftArrow from "./Pagination/Arrow Left.png";
import RightArrow from "./Pagination/Arrow Right.png";
import UpArrow from "./Pagination/Arrow Up.png";
import DownArrow from "./Pagination/Arrow Down.png";

/* Sort/Filter Icons */
import Ascending from "./SortFilter/Ascending@3x.png";
import Descending from "./SortFilter/Decending@3x.png";
import Download from "./SortFilter/Download.png";
import Upload from "./SortFilter/Upload.png";
import Filter from "./SortFilter/Filter.png";
import Search from "./SortFilter/Search.png";

/* Customer Service images */
import CSEggs from "./Eggs@3x.png";
import CSBeef from "./Beef@3x.png";
import CSPoultry from "./Poultry@3x.png";
import CSSeafood from "./Seafood@3x.png";
import CSProduce from "./Produce@3x.png";
import CSPhone from "./CustomerService/Telephone@3x.png";
import CSEmail from "./CustomerService/Fill@3x.png";

/* Polygons */
import polygonDefaultRight from "./polygon_default_right.png";
import polygonDefaultLeft from "./polygon_default_left.png";
import polygonHoverRight from "./polygon_hover _right.png";
import polygonHoverLeft from "./polygon_hover_left.png";

/* Collection Orders icons */
import info from "./info.png";
import infoBlue from "./info_bg_blue.png";
import infoOrange from "./info_bg_orange.png";

/* Nav icons */
import close from "./close.png";
import setting from "./setting.png";
import notification from "./notification.png";
import user from "./user.png";

/* Nav icons */
import crate from "./Crate.png";

/* User management icons */
import filter_icon from "./filter_icon.svg";
import edit_icon from "./edit_icon.svg";
import edit_icon_disabled from "./edit_icon_disabled.svg";
import edit_icon_hover from "./edit_icon_hover.svg";
import details_icon from "./details_icon.svg";
import details_icon_disabled from "./details_icon_disabled.svg";
import details_icon_hover from "./details_icon_hover.svg";
import active_status_active from "./active_status_active.svg";
import active_status_inactive from "./active_status_inactive.svg";

/* Doc Icon */
import xls1 from "./xls1.png";
import bulkSample from "./bulk-sample.png";
import bulkTransactionSample from "./bulk-transaction.png";
import drag_drop_icon from "./drag_drop_icon.png";

// Nav links SVG
import { ReactComponent as DashboardIcon } from "./Nav/dashboard.svg";
import { ReactComponent as SingleOrderIcon } from "./Nav/singleOrder.svg";
import { ReactComponent as BulkOrderIcon } from "./Nav/bulkOrder.svg";
import { ReactComponent as OrderHistoryIcon } from "./Nav/orderHistory.svg";
import { ReactComponent as RequestQuoteIcon } from "./Nav/requestQuote.svg";
import { ReactComponent as OrderLogIcon } from "./Nav/orderLog.svg";
import { ReactComponent as InvoiceIcon } from "./Nav/invoice.svg";
import { ReactComponent as TransactionsIcon } from "./Nav/transactions.svg";
import { ReactComponent as TransactionHistoryIcon } from "./Nav/transactionHistory.svg";
import { ReactComponent as ReturnsIcon } from "./Nav/returns.svg";
import { ReactComponent as FaqIcon } from "./Nav/faq.svg";
import { ReactComponent as FeedbackIcon } from "./Nav/feedback.svg";
import { ReactComponent as ContactIcon } from "./Nav/contact.svg";
import { ReactComponent as UsersIcon } from "./Nav/users.svg";

export const navIcons = {
  Dashboard: DashboardIcon,
  SingleOrder: SingleOrderIcon,
  BulkOrder: BulkOrderIcon,
  OrderHistory: OrderHistoryIcon,
  RequestQuote: RequestQuoteIcon,
  OrderLog: OrderLogIcon,
  Invoice: InvoiceIcon,
  Transactions: TransactionsIcon,
  TransactionHistory: TransactionHistoryIcon,
  Returns: ReturnsIcon,
  Faq: FaqIcon,
  Feedback: FeedbackIcon,
  Contact: ContactIcon,
  Users: UsersIcon,
};

export {
  header,
  logo,
  carrots,
  cheese,
  beef,
  eggs,
  chicken,
  default_user,
  underMaintenance,
  logoHorizontal,
};

export const customerService = {
  eggs: CSEggs,
  beef: CSBeef,
  poultry: CSPoultry,
  Seafood: CSSeafood,
  produce: CSProduce,
  phone: CSPhone,
  email: CSEmail,
};

export const login = {
  background: loginBackground,
  newLoginBackground: newLoginBackground,
  logoWhite: loginLogo,
  headerBk: loginHeaderBk,
  showPassword: showPassword,
  hidePassword: hidePassword,
  welcome: welcome,
};

export const logos = {
  logoWhite: logo_white,
  anytimeCollect: anytimeCollect,
  logo_white_bg_black_text: logo_white_bg_black_text,
};

export const icons = {
  beef: beef_ico,
  container: container_ico,
  eggs: eggs_ico,
  invoices: invoices_ico,
  poultry: poultry_ico,
  produce: produce_ico,
  returns: return_ico,
  van: van_ico,
  forward: forward,
  info: info_ico,
  calendar: calendar,
  filterIcon: filter_icon,
  editIcon: edit_icon,
  editIconDisabled: edit_icon_disabled,
  editIconHover: edit_icon_hover,
  detailsIcon: details_icon,
  detailsIconDisabled: details_icon_disabled,
  detailsIconHover: details_icon_hover,
  activeStatusActive: active_status_active,
  activeStatusInactive: active_status_inactive,
  remove: remove,
  edit: edit,
};

export const polygons = {
  polygonDefaultRight: polygonDefaultRight,
  polygonDefaultLeft: polygonDefaultLeft,
  polygonHoverRight: polygonHoverRight,
  polygonHoverLeft: polygonHoverLeft,
};

export const carousel = {
  carrots,
  cheese,
  beef,
  eggs,
  chicken,
};

export const containers = {
  tosca_ltd,
  tosca_new,
  gp,
  hays,
  orbis,
  polymerLogistics_6317,
  polymerLogistics_6332,
  polymerLogistics_6408,
  polymerLogistics_6411,
  polymerLogistics_6425,
};

export const status_icons = {
  Canceled,
  InReview,
  Processing,
  Received,
  Shipped,
  InTransit,
  TenderAccept,
};

export const pagination_icons = {
  LeftArrow,
  RightArrow,
  UpArrow,
  DownArrow,
};

export const sortfilter_icons = {
  Ascending,
  Descending,
  Filter,
  Download,
  Upload,
  Search,
};

export const collectionOrders = {
  info: info,
  infoBlue: infoBlue,
  infoOrange: infoOrange,
};

export const nav = {
  close: close,
  setting: setting,
  notification: notification,
  user: user,
};

export const crate_icons = {
  crate: crate,
};

export const doc_icon = {
  xls: xls1,
  bulkSample,
  upload: drag_drop_icon,
  bulkTransactionSample,
};
